import ErrorPage from "../views/page/error/ErrorPage";
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";

import MemberManage from "../views/page/member/MemberManage";
import MemberDetail from "../views/page/member/MemberDetail";
import MemberLeave from "../views/page/member/MemberLeave";
function RouterMember() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/Member/MemberManage" replace />} />
        <Route path="MemberManage" element={<MemberManage />} />
        <Route path="MemberManage/Detail/:user_seq" element={<MemberDetail />} />
        <Route path="MemberLeave" element={<MemberLeave />} />
        <Route path="MemberLeave/Detail/:user_seq" element={<MemberDetail />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </>
  );
}

export default RouterMember;
